<template>
    <o-dropdown position="bottom-left">
      <template #trigger>
        <a class="navbar-item between-center">
          <o-icon
              size="is-medium"
              pack="fa"
              icon="plus-circle">
          </o-icon>
          <span class="is-hidden-touch">Create</span>
        </a>
      </template>
        <o-dropdown-item has-link>
            <router-link :to="{ name: 'users.create' }">
                User
            </router-link>
        </o-dropdown-item>
        <o-dropdown-item has-link>
            <router-link :to="{ name: 'companies.create' }">
                Company
            </router-link>
        </o-dropdown-item>
        <o-dropdown-item has-link>
            <a @click="$emit('open-contact-modal')">Contact</a>
        </o-dropdown-item>
        <o-dropdown-item has-link>
            <router-link :to="{ name: 'tasks.create' }">
                Task
            </router-link>
        </o-dropdown-item>
        <o-dropdown-item has-link>
            <router-link :to="{ name: 'proposals.create' }">
                Proposals
            </router-link>
        </o-dropdown-item>
        <!--<o-dropdown-item has-link>-->
            <!--<a @click="$emit('open-reminder-modal')">Reminder</a>-->
        <!--</o-dropdown-item>-->
        <o-dropdown-item has-link>
            <a @click="$emit('open-time-log-modal')">Time Log</a>
        </o-dropdown-item>
    </o-dropdown>
</template>

<script>
    export default {
    }
</script>
